<script lang="tsx">
  import {
    defineComponent, PropType,
  } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import initStyle from './style'
  import { BeerStyleObj } from '../../../core'

  initStyle()

  export default defineComponent({
    name: 'DropdownOption',
    props: {
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({ }),
      },
      colorSvg: {
        type: Boolean,
        default: true,
      },
    },
    setup(props, { attrs, slots }) {
      return () => (
        <NewBsBox
          bs={{
            'cmp.overlayers.option': 'simple',
            ...props.bs,
          }}
          {...attrs}
        >
          <NewBsBox bs={{
            'cmp.overlayers.option.colorSvg': props.colorSvg,
            'cmp.overlayers.option': 'content',
          }}>
            {slots.default?.()}
          </NewBsBox>
          {slots.right?.()}
        </NewBsBox>
    )
    },
  })
</script>
